import * as angular from 'angular';

import { react2angular } from 'react2angular';

import MergeListingOptions from './MergeListingOptions';
import MergeListing from './MergeListing';

angular
  .module('caferealtor.listing.merge', ['ngRoute'])
  .config([
    '$routeProvider',
    ($routeProvider: any) => {
      $routeProvider
        .when('/listing/merge/options', {
          template: '<listing-merge-options />',
          reloadOnSearch: false,
        })
        .when('/listing/merge', {
          template: '<listing-merge />',
          reloadOnSearch: false,
        });
    },
  ])
  .component(
    'listingMergeOptions',
    react2angular(
      MergeListingOptions,
      [],
      ['$rootScope', '$compile', '$routeParams', '$window'],
    ),
  )
  .component(
    'listingMerge',
    react2angular(
      MergeListing,
      [],
      ['$rootScope', '$compile', '$routeParams', '$window'],
    ),
  );
